var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"loader"},[[_c('loader',{attrs:{"object":"#333","color1":"#ffffff","color2":"#17fd3d","size":"5","speed":"2","bg":"#343a40","objectbg":"#999793","opacity":"50","disableScrolling":"true","name":"dots"}})]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }